import { useMemo } from "react";

import type { VoucherI18n_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useInitMarketingVoucherI18nFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-model/server-model-to-input-model";
import { useVoucherI18nEditMutation } from "../../../repository/existing/mutation/use-voucher-i18n-edit-mutation";

import type { MarketingExistingVoucherI18nFormModelContextType } from "../../../../ui/existing/context/context";
import type { MarketingVoucherI18nFormModel } from "../../../type";

type Props = {
	serverModel: VoucherI18n_EditPageQuery;
};

export const useInitialized = ({ serverModel }: Props): MarketingExistingVoucherI18nFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(serverModel), [serverModel]);

	const queryData = undefined satisfies MarketingVoucherI18nFormModel["QueryData"];

	const { onSetViewModel, viewModel } = useInitMarketingVoucherI18nFormModelContext({ inputModel, queryData });

	const { onUpdate } = useVoucherI18nEditMutation();

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onUpdate: () => onUpdate({ ...viewModel }),
	};
};
